import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    shortListInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('savedItems', {
      getItemSavedStatus: 'getItemSavedStatus',
    }),
  },
  methods: {
    ...mapActions('savedItems', {
      getSavedItems: 'getSavedItems',
      addItem: 'addItem',
    }),
    saveItemAfterRegistration() {
      this.addItem(this.shortListInfo).then(() => {
      })
        .catch((error) => {
          this.$bugsnag.notify(new Error('Add shortlist item failure'), {
            severity: 'info',
            metaData: {
              'axios-error': error.data,
            },
          });
        });
    },
    saveItem() {
      this.getSavedItems().then(() => {
        if (this.getItemSavedStatus(this.shortListInfo) === true) {
          window.gtag.send({
            event: 'Successfully Shortlisted',
            action: 'Success',
          });
        } else {
          this.addItem(this.shortListInfo).then(() => {
          })
            .catch((error) => {
              this.$bugsnag.notify(new Error('Add shortlist item failure'), {
                severity: 'info',
                metaData: {
                  'axios-error': error.data,
                },
              });
            });
        }
      }).catch((error) => {
        this.$bugsnag.notify(new Error('item saved status failed'), {
          severity: 'info',
          metaData: {
            'axios-error': error.data,
          },
        });
      });
    },
    updateAnalytics(payload) {
      this.$gtag.send(payload);
    },
  },
};
